// OverflowContext.tsx
import React, {
  createContext,
  useContext,
} from 'react';

export interface OverflowItemData {
  id: string;
  priority: number;
  width: number;
  position: 'left' | 'middle' | 'right';
  menuComponent?: React.ReactNode;
}

interface OverflowContextValue {
  registerItem: (id: string, position: 'left' | 'middle' | 'right', priority: number, ref: HTMLElement | null) => void;
  registerItemMenuComponent(id: string, menuComponent: React.ReactNode): void;
  unregisterItem: (id: string) => void;
  containerRef: React.RefObject<HTMLElement>;
  isVisible: (id: string) => boolean;
  showMoreButton: boolean;
  setAnchorEl: (el: HTMLElement | null) => void;
}

export const OverflowContext = createContext<OverflowContextValue | null>(null);

export function useOverflowContext(): OverflowContextValue {
  const ctx = useContext(OverflowContext);
  if (!ctx) {
    throw new Error('useOverflowContext must be used within an OverflowProvider');
  }
  return ctx;
}
